var exports = {
  "z": "x804f0401--fe044d--root",
  "n": "x804f0401--fe044d--link",
};

module.exports = exports;
